import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import flashMessages from 'common/reducers/flashMessages';

export default combineReducers({
  flashMessages,
  form: formReducer,
});
